import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
})
export class LoaderComponent {
  useCase = 'Loading';
  selectedUseCase = 'Loading';
  useCases: string[] = [
    'Loading', 'Cargando', 'प्रगति चालू है'
  ];
  isBrowser = true as boolean;

  constructor(
    @Inject(PLATFORM_ID) public platformId: any
  ){
    this.isBrowser = isPlatformBrowser(this.platformId)
  }
}